module.exports = require('./helpers/bundle-url').getBundleURL('53Ql4') + "expand-button.0262b7b9.svg";